import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const PlayerRating: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.CLIENT_RATING_SHELL_ENABLED,
            value: value ? '1' : '0',
          })
        }
        value={settings.clientRatingShellEnabled}
        label={t('setting.client_rating')}
        description={t('settings.smartGamer.vote.rating.description_3')}
        emptyBg
        variant="secondary"
      />
    </>
  );
};
